<template>
  <div>
    <div v-if="!showInstructionsForm">
      <d-card-header class="border-bottom flex-header">
        <h6 class="m-0">
          Dyspozycje uruchomienia ({{ schedule.loan_installment_sum }} / {{ schedule.disposition_instructions_amount  + schedule.provision_instructions_amount }})
        </h6>
        <d-button
          v-if="instructionsList.length > 0"
          @click.prevent="downloadInstructionsFile"
          theme="primary"
          :class="{'btn-disabled': actionInProgress}">
          <i class="material-icons">download</i> Generuj PDF
        </d-button>

        <d-button
          @click.prevent="showInstructionForm(null)"
          theme="primary"
          :class="{ 'disabled is-disable': !isAddEnabled }"
          :disabled="!isAddEnabled">
          <i class="material-icons">add</i> Dodaj dyspozycję
        </d-button>
      </d-card-header>

      <d-alert
        v-if="!isAddEnabled"
        show
        theme="warning"
        class="my-4">
        <template v-if="scheduleFinished">
          Po zamknięciu umowy nie ma możliwości dodania dyspozycji
        </template>
        <template v-else-if="this.isCompanyChanged">
          Spółka została zmieniona w danych podstawowych. Należy zapisać umowę przed dodaniem dyspozycji.
        </template>
        <template v-else-if="!this.companyId">
          Wybierz spółkę aby mieć możliwość dodania dyspozycji
        </template>
      </d-alert>

      <instructions-list :instructions-list-prop="instructionsList" />
    </div>

    <instructions-form
      v-if="showInstructionsForm"
      :all-companies="allCompanies"
      :schedule-company-id="schedule.company_id"
      :schedule-contract-number="schedule.contract_number"
      :selected-instructions="selectedInstructions" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ClientUtils from '@/utils/client';
import FileSaver from 'file-saver';
import LarErrors from '@/helpers/Errors';
import InstructionsList from '@/components/client/contract-partials/instructions/InstructionsList.vue';
import InstructionsForm from '@/components/client/contract-partials/instructions/InstructionsForm.vue';

export default {
  name: 'ContractInstructionsTab',
  components: {
    ClientUtils,
    FileSaver,
    LarErrors,
    InstructionsList,
    InstructionsForm
  },
  props: {
    client: {
      required: true,
      type: Object
    },
    companyId: {
      default: null,
      type: Number
    },
    instructionsList: {
      default: () => [],
      type: Array
    },
    isDraft: {
      required: true,
      type: Boolean
    },
    schedule: {
      required: true,
      type: Object
    },
    scheduleFinished: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    ...mapGetters([
      'allCompanies'
    ]),
    clientName () {
      let nameArr = [];
      if (this.client.name) {
        nameArr.push(this.client.name);
      }

      if (this.client.surname) {
        nameArr.push(this.client.surname);
      }

      return nameArr.join(' ');
    },
    isAddEnabled () {
      if (this.isCompanyChanged || this.scheduleFinished || (this.isDraft && !(!!this.companyId))) {
        return false;
      }

      return true;
    },
    isCompanyChanged () {
      return (this.companyId !== this.schedule.company_id);
    }
  },
  data () {
    return {
      actionInProgress: false,
      selectedInstructions: null,
      showInstructionsForm: false
    }
  },
  mounted () {
    this.$bus.$on('contract-instructions-form-close', this.closeInstructions);
    this.$bus.$on('contract-instructions-form-show', this.showInstructionForm);
    this.getAllCompanies();
  },
  methods: {
    ...mapActions([
      'getAllCompanies'
    ]),
    showInstructionForm (instructionToEdit = null) {
      if (!instructionToEdit) {
        this.selectedInstructions = null;
        this.selectedInstructions = JSON.parse(JSON.stringify(ClientUtils._instructions));
        this.selectedInstructions.schedule_id = this.schedule.id;
        if (this.clientName) {
          this.selectedInstructions.recipient = this.clientName
        }
      } else {
        this.$set(this, 'selectedInstructions', _.clone(instructionToEdit));
      }

      this.$nextTick(() => {
        this.showInstructionsForm = true;
      })
    },
    closeInstructions (shouldReload = false) {
      this.showInstructionsForm = false;
      this.selectedInstructions = null;

      if (shouldReload) {
        this.$bus.$emit('contract-reload-instructions');
        this.$bus.$emit('reload-contract');
      }
    },
    downloadInstructionsFile () {
      this.actionInProgress = true;

      axios.post('api/contract-instructions/generate-pdf?date=' + Date.now(),
        { where: {
          client_id: this.client_id, schedule_id: this.schedule.id
        }},
        { responseType: 'blob' }
      ).then(response => {
        let blob = new File([response.data],
          this.clientName + '_dyzpozycje_uruchomienia_' + Vue.getCurrentDate() + '.pdf',);
        FileSaver.saveAs(blob);
        this.actionInProgress = false;
      }).catch((error) => {
        Vue.swal({
          title: 'Nie udało się pobrać pliku',
          text: 'Wystąpił błąd podczas pobierania. Spróbuj ponownie za jakiś czas.',
          type: 'error',
        });
        this.actionInProgress = false;
      });
    }
  },
  beforeDestroy () {
    this.$bus.$off('contract-instructions-form-close', this.closeInstructions);
    this.$bus.$off('contract-instructions-form-show', this.showInstructionForm);
  }
}
</script>
